module.exports = __webpack_public_path__ + "img/2mmxiaoding2.prt.81bb7ebc.jpg";